
import React, {FC} from 'react';
import {Modal} from 'react-bootstrap';

type ModalProps = {
	children: React.ReactNode
	onHide: () => void
}

const _Modal: FC<ModalProps> = ({children, onHide}) => {
	return (
		<Modal show size='lg' onHide={onHide}>
			<Modal.Header closeButton>
				Please pick a time slot
			</Modal.Header>
			<Modal.Body>
				{children}
			</Modal.Body>
		</Modal>
	);
};

export default _Modal;
